export default __webpack_public_path__ + "static/media/flag-nz.7e2fdf6b.svg";